import { Create, useForm } from '@refinedev/antd';
import { message } from 'antd';
import { useState } from 'react';

import { ServiceOrder } from '@/model/ServiceOrder/ServiceOrder';
import { ServiceOrderItem } from '@/model/ServiceOrder/ServiceOrderItem';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

import ServiceOrderForm from './ServiceOrderForm/ServiceOrderForm';

const ServiceOrderCreate = () => {
  const [serviceOrderItems, setServiceOrderItems] = useState<ServiceOrderItem[]>([]);
  const [hasInvalidDistribution, setHasInvalidDistribution] = useState(false);
  const { serviceOrderRepository } = useRepositoriesContext();
  const { formProps, saveButtonProps } = useForm<ServiceOrder>({
    successNotification: {
      message: 'Orden de servicio creada correctamente',
      type: 'success',
    },
    onMutationSuccess(serviceOrderResponse) {
      void serviceOrderRepository
        .saveServiceOrderItems(serviceOrderItems, serviceOrderResponse.data.id)
        .catch(error => {
          message.error('Ocurrió un error al guardar los items de la orden de servicio.');
          console.error('Error saving service order items:', error);
        });
    },
  });
  const saveButtonPropsWithValidation = {
    ...saveButtonProps,
    disabled: saveButtonProps?.disabled || hasInvalidDistribution,
  };

  return (
    <Create saveButtonProps={saveButtonPropsWithValidation}>
      <ServiceOrderForm
        formProps={formProps}
        serviceOrderItems={serviceOrderItems}
        setServiceOrderItems={setServiceOrderItems}
        onInvalidDistributionChange={setHasInvalidDistribution}
      />
    </Create>
  );
};

export default ServiceOrderCreate;
